import { render } from "./HomeSidebar.vue?vue&type=template&id=010c4dac&bindings={\"store\":\"setup\",\"folders\":\"setup\",\"filterBy\":\"setup\",\"addFolder\":\"setup\",\"closeSidebar\":\"setup\",\"deleteFolder\":\"setup\",\"renameFolder\":\"setup\",\"activeFilter\":\"setup\"}"
import script from "./HomeSidebar.vue?vue&type=script&lang=js"
export * from "./HomeSidebar.vue?vue&type=script&lang=js"
script.render = render

export default script